module.exports = __webpack_public_path__ + "static/Infographic4_6_Kaohsiung_mobile-e516d4994ae6d91efe2b7c048b4a9b7a.png";